var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "profile-icon",
    d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM5.042,11.768C5.3,11.228,6.872,10.7,8,10.7s2.706.528,2.958,1.068a4.755,4.755,0,0,1-5.916,0Zm6.774-.87C10.958,9.854,8.876,9.5,8,9.5s-2.958.354-3.816,1.4a4.8,4.8,0,1,1,7.632,0ZM8,4.4a2.1,2.1,0,1,0,2.1,2.1A2.095,2.095,0,0,0,8,4.4Zm0,3a.9.9,0,1,1,.9-.9A.9.9,0,0,1,8,7.4Z",
    transform: "translate(-2 -2)",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.5a814d9b.svg";
export { ForwardRef as ReactComponent };